import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetCompletedOrdersSlice = createSlice({
    name: "getCompletedOrders",
    initialState,
    reducers: {
        getCompletedOrdersRequest(state) {
            state.loading = true;
        },
        getCompletedOrdersRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getCompletedOrdersRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getCompletedOrdersRequest,
    getCompletedOrdersRequestSuccess,
    getCompletedOrdersRequestError,
} = GetCompletedOrdersSlice.actions;

export default GetCompletedOrdersSlice.reducer;
